// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fJIMT","colBig":"styles_colBig__3KEEd","colSmall":"styles_colSmall__Lh4pI","shopifyNameWrapper":"styles_shopifyNameWrapper__20_ZR"};